
var initModalWindows = function () {

    jQuery('.is-triggable').click(function(e) {

        e.preventDefault();
    
        var selector = jQuery(this).data();
        var rect = this.getBoundingClientRect();

        if (selector.activate) {

            var el = jQuery(selector.activate);
 
            jQuery('body').toggleClass('is-overflow-hidden');
            el.toggleClass('is-visible');
    
            return;
        }
        
        var el = jQuery(selector.deactivate);

        jQuery('body').toggleClass('is-overflow-hidden');
        el.toggleClass('is-visible');
    });

    jQuery(window).keydown(function(e){
        if (e.keyCode == 27) { 
            jQuery('body').toggleClass('is-overflow-hidden');
            jQuery('.modal').removeClass('is-visible');
        }
    });
}

export {
    initModalWindows
};